// const URL = 'http://localhost:8000';
const URL = 'https://ecommercebackend-owq9.onrender.com';
export default URL;